'use client';

import type { CohesionConfig } from '@highereducation/api-clients';
import { newrelic } from '@hen-site/lib/newrelic/client';

/**
 * Asserts that the per-tenant CohesionConfig carries the keys required to
 * bootstrap Tagular. The Cohesion snippet renders a `<script>` that
 * invokes Tagular on `DOMContentLoaded`; if `sourceKey` or `writeKey`
 * are missing the script silently fails and every downstream Tagular
 * event (ProductLoaded, FormSubmitted, etc.) is dropped without signal.
 */
export const isCohesionConfigValid = (
  cohesionConfig?: CohesionConfig | null,
): boolean => {
  const sourceKey = cohesionConfig?.tagular?.sourceKey;
  const writeKey = cohesionConfig?.tagular?.writeKey;

  return Boolean(sourceKey && writeKey);
};

/**
 * Reports a malformed CohesionConfig to New Relic.
 */
export const reportInvalidCohesionConfig = (
  cohesionConfig?: CohesionConfig | null,
): void => {
  const sourceKey = cohesionConfig?.tagular?.sourceKey;
  const writeKey = cohesionConfig?.tagular?.writeKey;

  newrelic.noticeError?.(new Error('CohesionConfigInvalid'), {
    hasSourceKey: Boolean(sourceKey),
    hasWriteKey: Boolean(writeKey),
  });
};
